import { PATH_PREFIX } from '../../apiUrls';

export const ApiEndpoints = {
  openIssuesList: `${PATH_PREFIX}/sw/api/open_improvements/`,
  archivedInstancesList: `${PATH_PREFIX}/sw/api/archived_instances/`,
  scheduledInstancesList: `${PATH_PREFIX}/sw/api/scheduled_instances/`,
  executedInstancesList: `${PATH_PREFIX}/sw/api/executed_instances/`,
  failedInstancesList: `${PATH_PREFIX}/sw/api/failed_instances/`,
  allInstancesList: `${PATH_PREFIX}/sw/api/all_instances/`,
  elementsList: `${PATH_PREFIX}/sw/api/all_elements`,
  draftElementsList: `${PATH_PREFIX}/sw/api/draft_elements`,
  invalidElementsList: `${PATH_PREFIX}/sw/api/invalid_elements`,
  inProgressInstancesList: `${PATH_PREFIX}/sw/api/in_progress_instances/`,
  activitiesTemplatesList: `${PATH_PREFIX}/sw/api/activities_templates/`,
  draftActivitiesList: `${PATH_PREFIX}/sw/api/draft_activities/`,
  supersededElementsActivitiesList: `${PATH_PREFIX}/sw/api/superseded_elements_activities/`,
  pendingApprovalsList: `${PATH_PREFIX}/sw/api/pending_approvals/`,
  invalidActivitiesTemplatesList: `${PATH_PREFIX}/sw/api/invalid_activities_templates/`,
  allTimeConfirmationsList: `${PATH_PREFIX}/sw/api/all_time_confirmations/v2/`,
  d2InstructionsList: `${PATH_PREFIX}/sw/api/d2_instructions/`,
};
